import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';

const APP_ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;
const isSentryEnabled = APP_ENV === 'production' && Boolean(process.env.REACT_APP_SENTRY_DSN);

if (isSentryEnabled) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: APP_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
  });
} else if (process.env.NODE_ENV !== 'production') {
  console.info('[Sentry] Disabled for env:', APP_ENV);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
